import {Action, Icon} from '@sail/ui';
import {chevronDown} from '@sail/icons/react/Icon';
import {NetworkSelector} from 'src/v2/components/walletConnect/NetworkSelector';
import {WalletCard} from 'src/v2/components/wallet/WalletCard';
import {WalletConnectionPendingOverlay} from 'src/v2/components/walletConnect/WalletConnectionPendingOverlay';
import {WalletConnectQrCode} from 'src/v2/components/walletConnect/WalletConnectQrCode';
import {useIsWalletConnecting} from 'src/v2/components/walletConnect/useIsWalletConnecting';
import {getStore, setValue} from 'src/v2/state/store';
import {ErrorBanner} from 'src/v2/components/error/ErrorBanner';
import {isMobile} from 'src/utils/utils';
import {ScreenContentLayout} from 'src/v2/components/screen/ScreenContentLayout';
import {useIsAnyCryptoWalletConnectFlow} from 'src/v2/components/anyCrypto/useIsAnyCryptoWalletConnectFlow';

export const WalletConnectScreen = () => {
  const {startWalletConnection, isWalletConnecting} = useIsWalletConnecting();
  const store = getStore();
  const newWallet = store.useSelector((state) => state.newWallet);
  const isAnyCryptoWalletConnectFlow = useIsAnyCryptoWalletConnectFlow();

  if (!newWallet) {
    throw new Error('newWallet is required in WalletConnectScreen');
  }

  const onBack = isAnyCryptoWalletConnectFlow
    ? () =>
        setValue((state) => {
          state.screen = 'WALLET_SELECT';
        })
    : undefined;

  return (
    <>
      <ScreenContentLayout onBack={onBack}>
        <WalletCard
          wallet={{
            option: newWallet.walletOption,
          }}
          headerActions={
            isAnyCryptoWalletConnectFlow ? undefined : (
              <Action
                onPress={() => {
                  store.setValue((state) => {
                    state.screen = 'WALLET_SELECT';
                  });
                }}
              >
                <Icon icon={chevronDown} size="xsmall" />
              </Action>
            )
          }
          bottomContent={
            newWallet.walletOption.provider === 'WalletConnect' &&
            !isMobile() ? (
              <WalletConnectQrCode />
            ) : (
              <NetworkSelector startWalletConnection={startWalletConnection} />
            )
          }
        />
        <ErrorBanner />
      </ScreenContentLayout>
      {isWalletConnecting ? <WalletConnectionPendingOverlay /> : null}
    </>
  );
};
